var map = {
	"./Fingerprint.svg": 8174,
	"./aaruush.svg": 9263,
	"./envision.svg": 484,
	"./linkskeeper.svg": 9931,
	"./sih.svg": 374,
	"./sun.svg": 2396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4415;